import {CriteriaCard, LabeledEditor} from "../pages/selection/useFanCriteria";
import React from "react";
import {SimulationRequestJson} from "../business/ApiJsonTypes";
import {createInternationalizationPrefixer} from "../platform/i18n/i18n";
import {OneOfEditor} from "../form/editors/OneOfEditor";
import {OptionalEditor} from "../form/editors/OptionalEditor";
import {MeasureEditorValue} from "../form/editors/MeasureEditor";
import {UsedConfigurationSummary} from "../business/useImpellerDatasheet";

// Note prefix is reused with criteria due to duplication and to avoid duplicating language keys
const t = createInternationalizationPrefixer("FanSelectionCriteriaControls");


export function MechanicalConfigurator(props: {
    availableShaftDiameters: number[],
    predefinedCriteria: SimulationRequestJson, // Bit unexpected type, but it is used to generate datasheet also

    supportAndClutchDiscSideEditor: OneOfEditor;
    shaftDiameterEditor: OptionalEditor<string>;
    impellerHeightEditor: OptionalEditor<MeasureEditorValue>;
    currentlyConfiguredSimulationRequestJson: SimulationRequestJson;
    airflowRelativeClutchMountingSideEditor: OneOfEditor;
    shaftLengthEditor: OptionalEditor<MeasureEditorValue>;
    screwMEditor: OptionalEditor<MeasureEditorValue>;
    threadLengthEditor: OptionalEditor<MeasureEditorValue>;
    fanMountingOrientationEditor: OneOfEditor;
    realizeWithClutchEditor: OneOfEditor;
    usedConfigurationSummary: UsedConfigurationSummary | null
}) {


    return <CriteriaCard>
        {/*<LabeledEditor label={t("Wykonanie łopat")} editor={bladeManufacturingTypeEditor}/>*/}
        {/*<LabeledEditor label={t("Materiał konstrukcji")} editor={preferredConstructionMaterialEditor}/>*/}
        {/*<LabeledEditor label={t("Materiał części złącznych")} editor={preferredFastenersMaterialEditor}/>*/}

        <LabeledEditor label={t("Średnica wału")} editor={props.shaftDiameterEditor} hint={props.usedConfigurationSummary !== null && !props.shaftDiameterEditor.enabled ? props.usedConfigurationSummary.shaftDiameter.toFixed(0) : ""}/>
        <LabeledEditor label={t("Długość wału")} editor={props.shaftLengthEditor}hint={props.usedConfigurationSummary !== null && !props.shaftLengthEditor.enabled  ? props.usedConfigurationSummary.shaftLength.toFixed(1) : ""}/>
        <LabeledEditor label={t("M Gwintu wału")} editor={props.screwMEditor}hint={props.usedConfigurationSummary !== null && !props.screwMEditor.enabled  ? props.usedConfigurationSummary.mforShaftThread+"" : ""}/>
        <LabeledEditor label={t("Dł. gwintu wału")} editor={props.threadLengthEditor}hint={props.usedConfigurationSummary !== null && !props.threadLengthEditor.enabled  ? props.usedConfigurationSummary.shaftThreadLength.toFixed(1) : ""}/>


        <LabeledEditor label={t("Wysokość wirnika")} editor={props.impellerHeightEditor}hint={props.usedConfigurationSummary !== null && !props.impellerHeightEditor.enabled  ? props.usedConfigurationSummary.impellerHeight.toFixed(0) : ""}/>

        <LabeledEditor label={t("Kierunek wirnika")} editor={props.fanMountingOrientationEditor}/>

        <LabeledEditor label={t("Wykonanie ze sprzęgłem")} editor={props.realizeWithClutchEditor}/>

        <LabeledEditor label={t("Pozycja sprzęgła")} editor={props.airflowRelativeClutchMountingSideEditor}/>
        <LabeledEditor label={t("Podpory i sprzęgło wzgl. tarczy")} editor={props.supportAndClutchDiscSideEditor}/>


        {/*<LabeledEditor label={t("Miękki start")} editor={softStartPresentEditor}/>*/}

    </CriteriaCard>

}